import gql from 'graphql-tag';

export const logIn = gql`
  mutation logIn($studentCode: String!, $password: String!) {
    login(credentials: { studentCode: $studentCode, password: $password }) {
      token
      refreshToken
    }
  }
`;

export const refreshToken = gql`
  mutation refreshToken($refreshToken: String!) {
    refreshToken(token: { refreshToken: $refreshToken }) {
      token
      refreshToken
    }
  }
`;

export const logOut = gql`
  mutation logOut($instanceId: String!) {
    logout(instance: { instanceId: $instanceId }) {
      instanceId
      status
    }
  }
`;
